import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  // Check if user is authenticated
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    const checkAuth = () => {
      const authToken = localStorage.getItem('authToken');
      setIsAuthenticated(!!authToken);
    };
    
    checkAuth();
    
    // Listen for storage events (for when user logs in/out in another tab)
    window.addEventListener('storage', checkAuth);
    
    // Handle scroll events for header styling
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('storage', checkAuth);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className={`site-header ${isScrolled ? 'shadow-md' : ''}`}>
      <div className="container mx-auto">
        <div className="header-container">
          <Link to="/" className="site-logo">
            CoreLink<span>AI</span> Blog
          </Link>
          
          <button 
            className="mobile-menu-toggle md:hidden" 
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
          
          <nav className={`${isMobileMenuOpen ? 'block' : 'hidden'} md:block`}>
            <ul className="nav-menu">
              <li>
                {/* Regular <a> — this leaves the blog's /blog basename, so react-router <Link> would be wrong */}
                <a href="/" className="nav-link nav-link--main-site">
                  ← Main site
                </a>
              </li>
              <li>
                <Link
                  to="/categories"
                  className={`nav-link ${isActive('/categories') ? 'active' : ''}`}
                >
                  Categories
                </Link>
              </li>
              <li>
                <Link
                  to="/archive"
                  className={`nav-link ${isActive('/archive') ? 'active' : ''}`}
                >
                  Archive
                </Link>
              </li>
              {isAuthenticated && (
                <li>
                  <Link
                    to="/admin"
                    className={`nav-link ${isActive('/admin') ? 'active' : ''}`}
                  >
                    Admin
                  </Link>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
